import angular from "angular";
import { PayrollDashboardModule } from './dashboard/payroll-dashboard.module';
import { PayStubModule } from "./pay-stub/pay-stub.module";
import { PayrollProcessingModule } from "./payroll-processing/payroll-processing.module";
import { PayrollRoutingModule } from "./payroll-routing.module";
import { PayrollPolicyModule } from "./policy/payroll-policy.module";
import { PayrollReportsModule } from "./reports/payroll-reports.module";
import { PayrollSharedModule } from "./shared/payroll-shared.module";


/** A module related to calculating and displaying a company's payroll. */
export const PayrollModule = angular
    .module("apex.mainApp.payroll", [
        PayStubModule,
        PayrollDashboardModule,
        PayrollPolicyModule,
        PayrollProcessingModule,
        PayrollReportsModule,
        PayrollRoutingModule,
        PayrollSharedModule
    ])
    .name;
